import { Actions, ActionTypes } from "./actions";
import { State, getInitialState } from "./state";

const initialState = getInitialState();

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionTypes.setSearchCriteria:
      const { fromCountry, toCountry } = action.payload;

      return {
        ...state,
        toCountry,
        fromCountry,
        toLocationName: action.payload.toLocationName,
        fromLocationName: action.payload.fromLocationName,
        adults: action.payload.adults,
        children: action.payload.children
      };

    default:
      return state;
  }
};

export { reducer, getInitialState };
